export enum UserDetailTab {
  Activities = `activities`,
  Properties = `properties`,
}
